const pubMainRouter = [
    {
        path : '/publish/main',
        name : 'PUB_MAIN',
        component: () => import('@/views/publish/Main.vue')  ,
    },
    {
        path : '/publish/login',
        name : 'PUB_LOGIN',
        component: () => import('@/views/publish/login.vue')  ,
    },
    {
        path : '/publish/privacyPolicy',
        name : 'PUB_PRIVACY_POLICY',
        component: () => import('@/views/publish/PrivacyPolicy.vue')  ,
    },
    
]
export {pubMainRouter}